export default {
	awsBucketName: process.env.AWS_BUCKET,
	api_url: process.env.API_URL,
	aws_Url: process.env.Image_URL,
	// api_url:'http://0.0.0.0:9000/api/',
	stageS3Bucket: 'xbeestest',
	prodS3Bucket: 'xbees',
	awsDisputeBucketName : process.env.Dispute_Bucket
}



// WEBPACK FOOTER //
// ./src/constants.js